import { render, staticRenderFns } from "./NotificationSidebar.vue?vue&type=template&id=5414d0a4&"
import script from "./NotificationSidebar.vue?vue&type=script&lang=js&"
export * from "./NotificationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports